import { authenticatedRequest } from './base.service';

export interface Department {
  id: string;
  name: string;
  description?: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateDepartmentData {
  name: string;
  description?: string;
}

export interface PaginatedDepartments {
  data: Department[];
  total: number;
  page: number;
  limit: number;
}

const getToken = (): string => {
  const token = localStorage.getItem('finara_token');
  if (!token) throw new Error('No authentication token found');
  return token;
};

export const departmentsService = {
  async createDepartment(data: CreateDepartmentData): Promise<Department> {
    return authenticatedRequest<Department>(
      '/api/v1/departments',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async getDepartments(params?: {
    page?: number;
    limit?: number;
    name?: string;
    organizationId?: string;
  }): Promise<PaginatedDepartments> {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.name) queryParams.append('name', params.name);
    if (params?.organizationId) queryParams.append('organizationId', params.organizationId);

    const queryString = queryParams.toString();
    const url = `/api/v1/departments${queryString ? `?${queryString}` : ''}`;

    return authenticatedRequest<PaginatedDepartments>(url, {}, getToken());
  },

  async getDepartment(id: string): Promise<Department> {
    return authenticatedRequest<Department>(`/api/v1/departments/${id}`, {}, getToken());
  },

  async updateDepartment(id: string, data: Partial<CreateDepartmentData>): Promise<Department> {
    return authenticatedRequest<Department>(
      `/api/v1/departments/${id}`,
      {
        method: 'PATCH',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async deleteDepartment(id: string): Promise<void> {
    return authenticatedRequest<void>(
      `/api/v1/departments/${id}`,
      {
        method: 'DELETE',
      },
      getToken()
    );
  },
};
